import { render, staticRenderFns } from "./CapacityTable.vue?vue&type=template&id=70dfba89"
import script from "./CapacityTable.vue?vue&type=script&lang=js"
export * from "./CapacityTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports